module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAAF0lEQVR4nGNgYGD4jwPjlmBA5yADDAkA3LEP8XQq0aUAAAAASUVORK5CYII="